import Modal from "react-modal";
import {AiOutlineCloseCircle} from 'react-icons/ai';
import styles from './Dialog.module.css';

const Dialog = ({ children, onClose, title, style }) => {
  const customStyles = {
    overlay: {
      zIndex: 15,
      background: "rgba(0, 0, 0, 0.7)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0px",
      minWidth: "594px",
      border: "1px solid",
      borderColor: '#fff',
      maxHeight: "80vh",
      overflowY: "auto",
      maxWidth: 'calc(100vw - 2rem)'
    },
  };

  return (
    <Modal isOpen={true} style={customStyles} ariaHideApp={false}>
      <div className={styles['dialog-header']} style={style}>
      <h4 className="text-base font-bold">{title}</h4>
     {onClose && <AiOutlineCloseCircle onClick={onClose} className={styles['close-icon']} />}
      </div>
      {children}
    </Modal>
  );
};

export default Dialog;